import { connect } from "react-redux";
import { withRouter } from "react-router";
import * as Redux from "redux";
import { userLogin, userLogout } from "../../actions";
import { getMerchant } from "../../../Merchant/actions";
import CurrentUser from "./component";
import { userPermitted } from "../../selectors";
import { currentMerchantName } from "../../../Merchant/selectors";
import { IUserState } from "../../reducer";

export interface ICurrentUserProps {
  user: IUserState;
  permit: boolean;
  merchant_name: any;
}

export interface ICurrentUserActions {
  userLogin: () => void;
  userLogout: () => void;
  getMerchant: (merchant_id: number) => void;
}

const mapStateToProps = (state: any, props: any): ICurrentUserProps => {
  return {
    user: state.user,
    permit: userPermitted(state),
    merchant_name: currentMerchantName(state, props)
  };
};

const mapDispatchToProps = (
  dispatch: Redux.Dispatch<any>
): ICurrentUserActions => {
  return {
    ...Redux.bindActionCreators(
      { userLogin, userLogout, getMerchant },
      dispatch
    )
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CurrentUser)
);



// WEBPACK FOOTER //
// ./client/modules/User/components/CurrentUser/container.ts